export type NavigationItem = {
  label: string;
  path: string;
  requiresAuthentication?: boolean;
};

export const navigationItems: NavigationItem[] = [
  {
    label: "OpenAppCart",
    path: "/",
  },
  {
    label: "App Installation Guide",
    path: "/app-installation-guide",
  },
  {
    label: "Membership",
    path: "/membership",
  },
  {
    label: "Create Publisher Account",
    path: "/sign-in",
  },
  {
    label: "Publisher Log In",
    path: "/log-in",
  },
  {
    label: "Publish Your App",
    path: "/publish-your-app",
  },
  {
    label: "Discover Apps",
    path: "/discover-apps",
  },
  {
    label: "Publisher Dashboard",
    path: "/publisher-dashboard",
    requiresAuthentication: true,
  },
  {
    label: "Publisher Agreement",
    path: "/privacy-policies",
  },
];
